import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress, Alert, List, ListItem, ListItemButton, ListItemText, Divider, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function InboxPage() {
    const { token, currentUser } = useAuth();
    const navigate = useNavigate();
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchConversations = async () => {
        try {
            const { data } = await axios.get('/api/messaging', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setConversations(data);
        } catch (err) {
            setError('Failed to load conversations.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            fetchConversations();
        }
    }, [token]);

    const handleDeleteConversation = async (convoId) => {
        if (window.confirm("Are you sure you want to delete this conversation? It will only be deleted for you.")) {
            try {
                await axios.delete(`/api/messaging/${convoId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setConversations(conversations.filter(c => c._id !== convoId));
            } catch (err) {
                setError("Failed to delete conversation.");
            }
        }
    };

    if (loading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;

    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h4" gutterBottom>Inbox</Typography>
            <List>
                {conversations.length === 0 && <Typography>No conversations yet.</Typography>}
                {conversations.map((convo, index) => {
                    const otherUser = convo.participantDetails.find(p => p._id !== currentUser.id);
                    return (
                        <React.Fragment key={convo._id}>
                            <ListItem 
                                secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteConversation(convo._id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                }
                                disablePadding
                            >
                                <ListItemButton onClick={() => navigate(`/chat/${convo._id}`)}>
                                    <ListItemText
                                        primary={`Chat with ${otherUser?.username || 'Unknown'}`}
                                        secondary={`Regarding item: ${convo.itemDetails?.itemName || 'Deleted Item'}`}
                                    />
                                </ListItemButton>
                            </ListItem>
                            {index < conversations.length - 1 && <Divider />}
                        </React.Fragment>
                    );
                })}
            </List>
        </Paper>
    );
}

export default InboxPage;
